import React from 'react'
import InterAtHome from '../InternationalAtHome/component/InterAtHome'
import Benefit from "../InternationalAtHome/component/Benefit"
const InternationalAtHome = () => {
  return (
    <>
    <InterAtHome/>
    <Benefit/>
    </>
  )
}

export default InternationalAtHome